/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AbstractFinderGridDefinition } from '@gh/common-internal-shared';
import { NumberTypes } from '@gh/common-shared';
import { TranslationService } from '@gh/core-mls';
import { buildNumberColumn } from '@gh/core-ui-grid';
import { ColDef } from 'ag-grid-community';
import { getTaxRateId } from '../../resources';

@Injectable()
export class XeroTaxRateFinderDialogGridDefinition extends AbstractFinderGridDefinition {
  getId = getTaxRateId;

  constructor(private translationService: TranslationService) {
    super();
  }

  buildColumnDefs(): ColDef[] {
    return [
      {
        field: 'name',
        headerName: this.translationService.get('lbl_name'),
        width: 250,
      },
      {
        field: 'taxRate',
        headerName: this.translationService.get('lbl_rate'),
        width: 80,
        ...buildNumberColumn(NumberTypes.Rate),
      },
    ];
  }
}
